import { defaultMealItem } from '../constants/meals';
import { IMealChoice, IMealGroup, IMealItem } from 'src/types/combo';
import { IProductV4Size } from 'src/types/product';

export const convertMealId = (object: IProductV4Size | IMealGroup | IMealChoice | IMealItem) => {
  const isNew = !Number.isInteger(object.id);

  if (isNew) {
    const newObject = { ...object, front_id: object.id };
    delete newObject.id;
    return newObject;
  }

  return object;
};

export const getFakeMealItem = (size_id: number, group_id: number, choice_id: number): IMealItem => {
  return { ...defaultMealItem, size_id, group_id, choice_id, isFake: true };
};
